import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import useProductCategoriesAPI from '../../apis/productCategoriesAPI';
import { RxUpdate } from 'react-icons/rx';
import EventEmitter from '../../../utils/eventEmitter';


const costing_method = [
  {value: 'standard_price', label: 'Standard Price'},
  {value: 'average_cost', label: 'Average Cost (AVCO)' },
  {value: 'first_in_first_out', label: 'First In First Out (FIFO)'}
];

const inventory_valuation = [
  {value: 'manual', label: 'Manual'},
  {value: 'automatic', label: 'Automatic'}
]

const locationTypes = [{value: 'internal', label: 'Internal'}, {value: 'customer_location', label: 'Customer Locations'}];
const removalOptions = [{value: 'fifo', label: 'First In First Out (FIFO)'}, {value: 'lifo', label: 'Last In First Out (LIFO)'}];


const ProductCategoryChanges = () => {
  const { accounts, routes, journals, categories, category } = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState(category.name ? category.name : '');
  const { create, update } = useProductCategoriesAPI();
  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
    console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    data['id'] = category.id;
    update(category.seo, data, success);
    // console.log(data)
  };


  const handleDiscard = () => { };
  

  useEffect(() => {
    EventEmitter.subscribe('product_category_response', data => {
      navigate('/inventory/product-categories/'+data)
    });
    EventEmitter.subscribe('product_category_update', data => {
      navigate('/inventory/product-categories/'+data)
    });

    return () => {
      EventEmitter.unsubscribe('product_category_response');
      EventEmitter.unsubscribe('product_category_update');
    }
  },[])


  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/product-categories'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Product Cateogries</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ category.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip>
        </div>
        {category.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          name='routechanges'
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Category"
          value={name} 
          onChange={onChangeName}
        />
        <Form name="routes"
          form={form}
          labelAlign='left'
          labelCol={{ span: 10 }}
          labelWrap={true}
          initialValues={category.seo ? category : {}}
          disabled={category.seo ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Form.Item labelCol={{span: 4}} label='Parent Category' name="parent_category_id" className='font-semibold text-gray-800 mb-2 column' required >
            <Select options={categories.map(category => ({value: category.id, label: category.name}))} style={{width: '300px'}} className='border-x-0 border-t-0 input-outline-none font-normal' />
          </Form.Item>
          <Row className='mt-5'>
            <Col md={{ span: 11 }}>
            <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">LOGISTICS</Badge> 
              <Form.Item label='Routes' name="route_id" className='font-semibold text-gray-800 mb-2 column' required >
                <Select options={routes.map(route => ({value: route.id, label: route.name}))} className='border-x-0 border-t-0 input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Reserve Packaging' name='reserve_packaging' className='font-semibold text-gray-800 mb-2 column' required >
                <Radio.Group className='flex flex-column'>
                  <Space direction='vertical'>
                    <Radio value={'reserve_full_packaging'} className='font-normal'>Reserve Only Full Packagings</Radio>
                    <Radio value={'reserve_partial_packaging'} className='font-normal'>Reserve Partial Packagings</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col md={{span: 10, offset: 1}}>
              <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">INVENTORY VALUATION</Badge> 
              <Form.Item label='Costing Method' name="costing_method" className='font-semibold text-gray-800 mb-2 column' required >
                <Select options={costing_method} />
              </Form.Item>
              <Form.Item label='Inventory Valuation' name={'inventory_valuation'} className='font-semibold text-gray-800 mb-2 column' required >
                <Select options={inventory_valuation} />
              </Form.Item>
              
            </Col>
          </Row>
          <Row className='mt-5'>
            <Col md={{ span: 11 }}>
              <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">ACCOUNT PROPERTIES</Badge> 
              <Form.Item label='Income Account' name={'income_account'} className='font-semibold text-gray-800 mb-2 column' required >
                <Select options={accounts.filter(item => item.parent === 'Income').map(account => ({value: account.id, label: `${account.code} ${account.name}`}))} />
              </Form.Item>
              <Form.Item label='Expense Account' name={'expense_account'} className='font-semibold text-gray-800 mb-2 column' required >
                <Select options={accounts.filter(item => item.parent === 'Expense').map(account => ({value: account.id, label: `${account.code} ${account.name}`}))} />
              </Form.Item>
            </Col>
            <Col md={{span: 10, offset: 1}}>
              <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">ACCOUNT STOCK PROPERTIES</Badge> 
              <Form.Item label='Stock Valuation Account' name={'stock_valuation_account'} className='font-semibold text-gray-800 mb-2 column' required >
                <Select options={accounts.filter(item => item.parent === 'Assets').map(account => ({value: account.id, label: `${account.code} ${account.name}`}))} />
              </Form.Item>
              <Form.Item label='Stock Journal' name={'stock_journal_id'} className='font-semibold text-gray-800 mb-2 column' required >
                <Select options={[]} />
              </Form.Item>
              <Form.Item label='Stock Input Account' name={'stock_input_account'} className='font-semibold text-gray-800 mb-2 column' required >
                <Select options={accounts.filter(item => item.parent === 'Assets').map(account => ({value: account.id, label: `${account.code} ${account.name}`}))} />
              </Form.Item>
              <Form.Item label='Stock Output Account' name={'stock_output_account'} className='font-semibold text-gray-800 mb-2 column' required >
                <Select options={accounts.filter(item => item.parent === 'Assets').map(account => ({value: account.id, label: `${account.code} ${account.name}`}))} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}

export default ProductCategoryChanges;